<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Chapter-Title-No-Pagebreak">AUTHOR’S NOTE</p>
<p class="ORIM-Chapter-Opener-Paragraph">This story is based on primary, on-the-scene reporting in the bayous of Louisiana; the investigative transcript of the case; and extended interviews with the primary detectives. Some names have been changed in the interest of privacy. But every single victim is as he was.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Rosen_BayouStrangler_4P-3b.vue?af1935d2